import { render, staticRenderFns } from "./BossChatWindow.vue?vue&type=template&id=6821c5ee&"
import script from "./BossChatWindow.vue?vue&type=script&lang=ts&"
export * from "./BossChatWindow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports